"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChart = void 0;
var drawPlane_1 = require("../parse/drawPlane");
var getPlanes_1 = require("../parse/getPlanes");
var getIndexNearest_1 = require("../../common/getIndexNearest");
var LineChart = function (svg, config) {
    var _a = getPlanes_1.getPlanes(config), dataPointGroup = _a.dataPointGroup, yAxisMarks = _a.yAxisMarks, destPlane = _a.destPlane;
    drawPlane_1.drawPlane(svg, config, dataPointGroup[0], yAxisMarks, destPlane);
    var POINT_DIAMETER = 0;
    var path = dataPointGroup[0].map(function (it) { return "L " + it[0] + " " + it[1]; }).join(' ');
    var newPath = "M" + path.substr(1);
    svg.path(newPath).stroke({ color: config.values[0].color, width: 4 }).fill('transparent');
    dataPointGroup[0].map(function (it) { return svg.circle(POINT_DIAMETER).fill('#000').move(it[0] - POINT_DIAMETER / 2, it[1] - POINT_DIAMETER / 2); });
    if (config.cursorX) {
        var LINE_COLOR = '#000';
        var fontSize_1 = config.yAxis.fontSize || 30;
        var nearestIndex = getIndexNearest_1.getIndexNearest(dataPointGroup, config.cursorX);
        var index_1 = nearestIndex.indexX;
        var nearest_1 = nearestIndex.nearestX;
        svg.line(nearest_1[0], config.yAxis.marginStart, nearest_1[0], config.height - config.yAxis.marginEnd).stroke({ color: LINE_COLOR, width: 2 });
        svg.line(config.xAxis.marginStart, nearest_1[1], config.width - config.xAxis.marginEnd, nearest_1[1]).stroke({ color: LINE_COLOR, width: 2 });
        var yText_1 = "" + config.values[0].series[index_1];
        svg.rect(fontSize_1 * 0.58 * yText_1.length, fontSize_1 * 1.8).move(config.xAxis.marginStart - fontSize_1 * 3 - 5, nearest_1[1] - fontSize_1).fill({ color: config.backgroundColor || '#fff' });
        svg.text(function (tspan) { return tspan.move(fontSize_1 * 0.5, nearest_1[1] - fontSize_1)
            .text(yText_1)
            .font({ size: fontSize_1, weight: 'bold' }); });
        var xText_1 = "" + config.xAxis.series[index_1];
        svg.rect(fontSize_1 * 0.58 * xText_1.length + 8, fontSize_1 * 1.8 + 20).move(dataPointGroup[0][index_1][0] - (xText_1.length * fontSize_1 * 0.4) / 2 - 5, config.height - config.yAxis.marginEnd + 2).fill({ color: config.backgroundColor || '#fff' });
        svg.text(function (tspan) { return tspan.move(dataPointGroup[0][index_1][0] - (xText_1.length * fontSize_1 * 0.4) / 2, config.height - config.yAxis.marginEnd)
            .text(xText_1)
            .font({ size: fontSize_1, weight: 'bold' }); });
    }
    var getXY = function (x, y) { return getIndexNearest_1.getIndexNearest(dataPointGroup, x, y); };
    return { svg: svg, getXY: getXY };
};
exports.LineChart = LineChart;
